import { render, staticRenderFns } from "./DeclineWritingPanel.vue?vue&type=template&id=2b7cd7c0&"
import script from "./DeclineWritingPanel.vue?vue&type=script&lang=js&"
export * from "./DeclineWritingPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports